import { AppMenuListItemProps } from '@components/AppMenuListItem/AppMenuListItem';

export const BURGER_MENU_ADMIN_OPTIONS: AppMenuListItemProps[] = [];
